import { Box } from "@mui/material";
// sections
import PosHero from "./PosHero";
import KeyFeaturesCarousel from "./KeyFeaturesCarousel";
import Integration from "./Integration";

// ----------------------------------------------------------------------

export default function Pos() {
  return (
    <>
      <Box>
        <PosHero />
        <KeyFeaturesCarousel />
        <Integration />
      </Box>
    </>
  );
}
